export default {
    raw_data_tab_filter_by_last: "Más recientes",
    raw_data_tab_filter_by_date: "Entre",
    raw_data_tab_apply_filters: "Aplicar",
    raw_data_tab_id: "ID",
    raw_data_tab_server_time: "Fecha de lectura",
    raw_data_tab_unit_time: "Fecha de reporte",
    raw_data_tab_latitude: "Latitud",
    raw_data_tab_longitude: "Longitud",
    raw_data_tab_raw_event: "Evento",
    raw_data_tab_dist: "Dist",
    raw_data_tab_speed: "Velocidad del GPS",
    raw_data_tab_ecu_speed: "Velocidad ECU",
    raw_data_tab_gps_event_address: "Dirección",
    raw_data_tab_landmark_id: "ID punto de interes",
    raw_data_tab_satellites: "Satelites",
    raw_data_tab_inputs: "Entradas",
    raw_data_tab_raw: "No Procesado",
    raw_data_tab_raw_data_modal_title: "Sin Procesar",
    raw_data_tab_raw_data_modal_cancel: "Cancelar",
    raw_data_tab_raw_data_modal_copy: "Copiar",
    raw_data_tab_raw_data_modal_copied: "Copiado!",
    raw_data_tab_accumulator: "ACC",
    raw_data_tab_type: "Tipo",
    raw_data_tab_update_time: "Fecha Actualización",
    raw_data_tab_fix_time: "Fecha Ajuste",
    raw_data_tab_recived_at: "Recibido",
    raw_data_tab_direction: "Dirección",
    raw_data_tab_altitude: "Altitud",
    raw_data_tab_event: "Nombre del Evento",
    raw_data_tab_network_id: "Red Id",
    raw_data_tab_unit_status: "Estado Unidad",
    raw_data_tab_seq_num: "Seq Num",
    raw_data_tab_msg_id: "MSG Id",
    raw_data_tab_fix_status: "Fix Status",
    raw_data_tab_comm_state: "Comm State",
    raw_data_tab_records: "registros",
    raw_data_tab_heading: "Rumbo",
    raw_data_tab_ignition: "Encendido",
    raw_data_tab_ignition_on: "Encendida",
    raw_data_tab_ignition_off: "Apagada",
    raw_data_tab_event_received: "Evento recibido",
    raw_data_tab_update_time: "Tiempo Actualización",
    raw_data_tab_fix_time: "Tiempo Localización",
    raw_data_tab_fix_status: "Estado Localización",
    raw_data_tab_received_at: "Recibido",
    raw_data_tab_message_type: "Tipo de Mensaje",
    raw_data_tab_device_id: "Id del Dispositivo",
    raw_data_tab_satellites: "Satelites",
    raw_data_tab_hdop: "Hdop",
    raw_data_tab_direction: "Dirección",
    raw_data_tab_event_code: "Evento en Bruto",
    raw_data_tab_event_index: "Índice Evento",
    raw_data_tab_accumulator_count: "Contador Acumulador",
    raw_data_tab_accumulator0: "Acumulador 0",
    raw_data_tab_accumulator1: "Acumulador 1",
    raw_data_tab_accumulator2: "Acumulador 2",
    raw_data_tab_accumulator3: "Acumulador 3",
    raw_data_tab_accumulator4: "Acumulador 4",
    raw_data_tab_accumulator5: "Acumulador 5",
    raw_data_tab_accumulator6: "Acumulador 6",
    raw_data_tab_accumulator7: "Acumulador 7",
    raw_data_tab_accumulator8: "Acumulador 8",
    raw_data_tab_accumulator9: "Acumulador 9",
    raw_data_tab_accumulator10: "Acumulador 10",
    raw_data_tab_accumulator11: "Acumulador 11",
    raw_data_tab_accumulator12: "Acumulador 12",
    raw_data_tab_accumulator13: "Acumulador 13",
    raw_data_tab_accumulator14: "Acumulador 14",
    raw_data_tab_accumulator15: "Acumulador 15",
    raw_data_tab_accumulator16: "Acumulador 16",
    raw_data_tab_accumulator17: "Acumulador 17",
    raw_data_tab_accumulator18: "Acumulador 18",
    raw_data_tab_accumulator19: "Acumulador 19",
    raw_data_tab_accumulator20: "Acumulador 20",
    raw_data_tab_accumulator21: "Acumulador 21",
    raw_data_tab_accumulator22: "Acumulador 22",
    raw_data_tab_accumulator23: "Acumulador 23",
    raw_data_tab_accumulator24: "Acumulador 24",
    raw_data_tab_accumulator25: "Acumulador 25",
    raw_data_tab_accumulator26: "Acumulador 26",
    raw_data_tab_accumulator27: "Acumulador 27",
    raw_data_tab_accumulator28: "Acumulador 28",
    raw_data_tab_accumulator29: "Acumulador 29",
    raw_data_tab_accumulator30: "Acumulador 30",
    raw_data_tab_accumulator31: "Acumulador 31",
    raw_data_tab_comm_state: "Estado Comm",
    raw_data_tab_rssi: "Rssi",
    raw_data_tab_network_id: "Id de Red",
    raw_data_tab_inputs: "Entradas",
    raw_data_tab_unit_state: "Estado Unidad",
    raw_data_tab_seq_num: "# Secuencia",
    raw_data_tab_app_msg: "Mensaje App",
    raw_data_tab_app_msg_type: "Tipo Mensaje App",
    raw_data_tab_msg_route: "Mensaje Ruta",
    raw_data_tab_user_msg: "Mensaje Usuario",
    raw_data_tab_mobile_id: "Id Móvil",
    raw_data_tab_raw_data: "Datos sin Procesar",
    raw_data_tab_db_time_spam: "Fecha de Db",
    raw_data_tab_gateway_received_at: "Recepción el",
    raw_data_tab_event_time: "Fecha Evento",
    raw_data_tab_serial_number: "# serial",
    raw_data_tab_event_text: "Evento",
    raw_data_tab_fix_age: "Edad de Localización",
    raw_data_tab_ignition_duration: "Duración de Ignicion",
    raw_data_tab_total_idle_duration: "Duración Total de Inactividad",
    raw_data_tab_duration: "Duración",
    raw_data_tab_fence_id: "Id de Cerca",
    raw_data_tab_batt_volt: "Voltaje Batería",
    raw_data_tab_int_batt_volt: "Int Voltaje Batería",
    raw_data_tab_ack_req: "Ack Req",
    raw_data_tab_format_checksum: "Formato Checksum",
    raw_data_tab_format_string: "Formato",
    raw_data_tab_raw_message: "Mensaje sin Procesar ",
    raw_data_tab_unavailable_view: "Vista no disponible",
    raw_data_tab_hdop: "HDop",
    raw_data_tab_vdop: "VDop",
    raw_data_tab_speed_limit: "Limite de Velocidad",
    raw_data_tab_ignition_status: "Estado de Encendido",
    raw_data_tab_notification_type: "Tipo de Notificación",
    raw_data_tab_trip_id: "Id de Viaje",
    raw_data_tab_picture_id: "Id de la imagen",
    raw_data_tab_event_category: "Categoria de Evento",
    raw_data_tab_event_level: "Nivel de Evento",
    raw_data_tab_camera_clip_key: "Llave del clip de la cámara",
    raw_data_tab_camera_clip_offset: "Des. del clip de la cámara",
    raw_data_tab_clip_id: "Clip Id",
    raw_data_tab_duration: "Duración",
    raw_data_tab_rotate: "Girar",
    raw_data_tab_camera_status: "Estado de Camára",
    raw_data_tab_idle_status: "Estado de Inactividad",
    raw_data_tab_sdcard_status: "Estado de SDCard",
    raw_data_tab_data_usage_in_kb: "Uso de Dato en KB",
    raw_data_tab_transaction_id: "Id de Transacción",
    raw_data_tab_status: "Estado",
    raw_data_tab_error_msg: "Mensaje de Error",
    raw_data_tab_valid_time_range: "Intervalo Valido",
    raw_data_tab_warning: "Advertencia",
    raw_data_tab_last_message_time: "Fecha del Ultimo Mensaje",
    raw_data_tab_account_id: "Id de cuenta",
    raw_data_tab_date_range: "Por favor seleccione un rango de fechas valido",
    raw_data_tab_sequenceNumber: "# de Secuencia",
    raw_data_tab_driver_name: "Conductor",
    raw_data_tab_device_reading_info: "Información de lectura del dispositivo",
    raw_data_tab_distance: "Distancia",
    raw_data_tab_accumulated_distance: "Distancia acumulada",
    raw_data_tab_engine_hours: "Horas del motor",
    raw_data_tab_engine_odometer: "Odómetro del motor",
    raw_data_tab_hdop: "HDOP",
    raw_data_tab_vdop: "VDOP",
    raw_data_tab_rssi: "RSSI",
    raw_data_tab_ecu_engine_hours: "Horas motor ECU",
    raw_data_tab_ecu_engine_odometer: "Odometro del motor ECU",
    raw_data_tab_battery_level: "Nivel de Batería",
    raw_data_tab_engineHours_off: "Horas del motor + Off",
    raw_data_tab_ecu_engineHours_off: "Horas motor ECU + Off",
    raw_data_tab_engineOdometer_off: "Odómetro del motor + Off",
    raw_data_tab_ecu_engineOdometer_off: "Odometro del motor ECU + Off",
    raw_data_tab_video_player: "Reproducir video",
};